import { Link } from "react-router-dom"

const WishlistCourseCard = ({ course }) => {
  const renderStars = (rating) => {
    const stars = []
    for (let i = 1; i <= 5; i++) {
      stars.push(<i key={i} className={`fas fa-star ${i <= rating ? "text-warning" : "text-muted"}`}></i>)
    }
    return stars
  }

  return (
    <div className="wishlist-course-card mb-4">
      <div className="card">
        <div className="row g-0">
          <div className="col-md-4">
            <Link to={`/course/${course.id}`}>
            <img
                src={course.image || "/placeholder.svg"}
                alt={course.title}
                className="wishlist-course-image"
              />
            </Link>
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <div className="d-flex align-items-center mb-2">
                <div className="stars me-2">{renderStars(course.rating)}</div>
                <span className="rating-value">
                  {course.rating.toFixed(1)} {course.reviewCount ? `(${course.reviewCount})` : ""}
                </span>
              </div>

              <h5 className="card-title mb-3">
                <Link to={`/course/${course.id}`} className="text-decoration-none text-dark">
                  {course.title}
                </Link>
              </h5>

              <div className="instructor-info mb-3 d-flex align-items-center">
                <span className="text-muted me-2">By</span>
                <img
                  src={course.instructor.image || "/placeholder.svg"}
                  alt={course.instructor.name}
                  className="instructor-avatar me-2"
                  onError={(e) => (e.target.src = "/placeholder.svg")}
                />
                <span className="instructor-name text-warning">{course.instructor.name}</span>
              </div>

              <Link to={`/course/${course.id}`} className="btn btn-outline-warning">
                Continue Learning
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WishlistCourseCard
